import styled from "styled-components";

export const LogoCont = styled.div`
  height: auto;
  width: 3rem;
`;

export const LogoImg = styled.img`
  margin: 0.5rem;
  margin-bottom: 0;
  height: 90%;
  width: 90%;
`;
